import { DebugService } from './debug.service';

class _CookieService {
  debug: DebugService;
  constructor() {
    this.debug = new DebugService('CookieService');
  }

  getCookie(key: string) {
    return document.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith(key))
      ?.split('=')[1];
  }
}

export const CookieService = new _CookieService();
